import { css } from "@web/helpers/webComponents";

const styles: string = css`

`;

class TimerComponent extends HTMLElement {
    private timerId: NodeJS.Timeout | null = null;
    private time: number = 1200;
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    private leftTime: string = "0";

    private start(): void {
        this.timerId = setInterval(() => {
            this.time -= 1;

            if (this.time <= 0) {
                this.stop();
            }
        }, 1000);
    }

    private stop(): void {
        if (this.timerId) {
            clearInterval(this.timerId);
        }
    }

    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        this.start();

        this.shadowRoot.innerHTML = `
            <style>${styles}</style>
            ${this.leftTime}
        `;
    }
}

customElements.define("game-timer", TimerComponent);
